import {
    combineReducers,
} from 'redux';
import {
    routerReducer
} from 'react-router-redux';
import auth from '../container/LoginPage/reducer';
import reports from '../container/ReportsPage/reducer';
import users from '../container/AdminUsersPage/reducer';

export default combineReducers({
    router: routerReducer,
    auth,
    reports,
    users,
});



// WEBPACK FOOTER //
// ./app/web/src/reducers/index.js